module.exports = __webpack_public_path__ + "img/diamond-ore.378146db.png";